<template>
  <v-container class="page">
    <v-data-table
      :headers="headers"
      :items="dataApi"
      sort-by="username"
      class="elevation-1 font-weight-light pa-5"
    >
      <template #top>
        <v-toolbar flat>
          <v-toolbar-title style="color:#00ACDC">
            User List
          </v-toolbar-title>
        </v-toolbar>
      </template>
      <!-- <template v-slot:item>
        <v-skeleton-loader
          v-if="item == []"
          class="mx-auto"
          type="table-tbody"
        ></v-skeleton-loader>
      </template> -->
      <template #[`item.metadata.photo`]="{ item }">
        <a @click="showPhoto(item)">Show</a>
      </template>
      <template #[`item.action`]="{ item }">
        <a
          @click="showPhoto(item)"
          v-bind="attrs"
          v-on="on"
        >Show profile</a>
      </template>
    </v-data-table>
    <v-dialog
      v-model="showPhotoDialog"
      max-width="500"
    >
      <v-card>
        <v-img
          :src="photoUrl"
        />
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="error"
            text
            @click="showPhotoDialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
const crypto = require("crypto");
// eslint-disable-next-line no-unused-vars
const md5 = (data) =>
  crypto
    .createHash("md5")
    .update(data)
    .digest("hex");

export default {
  data: () => ({
    headers: [
      {
        text: "Username",
        align: "left",
        value: "username",
      },
      { text: "First Name", value: "first_name" },
      { text: "Last Name", value: "last_name" },
      { text: "Email", value: "email" },
      { text: "Actions", value: "action", sortable: false },
    ],
    dataApi: [],
    dataTimezone: [],
    dataCompany: [],
    token: "",
    showPhotoDialog: false,
    photoUrl: "",
  }),
  created() {
    this.clientid = this.$store.state.clientid;
    this.token = this.$store.state.token;
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  mounted() {
    this.getData();
    this.getTimezone();
    this.getCompany();
  },
  methods: {
    getData() {
      this.token = this.$store.state.token;
      this.clientid = this.$store.state.clientid;
      if (this.$store.state.type == 1 || this.$store.state.type == 3 || this.$store.state.type == 4) {
        this.$store.dispatch('API_CALL', {
            $method: 'get_all',
            $postData: {
              clientid: this.clientid,
            },
          })
          .then((response) => {
            this.dataApi = response.data.data.filter(
              (data) => data.status == 2
            );
          });
      }
    },
    getTimezone() {
      this.token = this.$store.state.token;
      this.$store.dispatch('API_CALL', {
          $method: 'get_timezone',
        })
        .then((response) => {
          this.dataTimezone = response.data.data;
        });
    },
    getCompany() {
      this.token = this.$store.state.token;
      this.$store.dispatch('API_CALL', {
          $method: 'get_all_company'
        })
        .then((response) => {
          if (this.$store.state.type == 3) {
            this.dataCompany = response.data.data.filter(
              (companies) => companies.active == 1
            );
          }
        });
    },
    showPhoto(item) {
      this.photoUrl = `https://local-government.street-directory.com.au/${item.metadata.photo}`;
      this.showPhotoDialog = true;
    },
  },
};
</script>
